import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Security',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Charities',
      description: 'All organizations are thoroughly vetted and verified'
    },
    {
      icon: 'Lock',
      title: 'Privacy Protected',
      description: 'We never share your personal information with third parties'
    },
    {
      icon: 'Award',
      title: 'Tax Compliant',
      description: 'Automatic tax documentation for all your donations'
    }
  ];

  const stats = [
    { value: '50K+', label: 'Active Donors' },
    { value: '$2.5M+', label: 'Donated This Year' },
    { value: '500+', label: 'Verified Charities' },
    { value: '4.9/5', label: 'User Rating' }
  ];

  return (
    <div className="space-y-8">
      {/* Trust Features */}
      <div className="bg-muted/30 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
          Why donors trust Share Good
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {trustFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-sm text-foreground">
                  {feature?.title}
                </h4>
                <p className="text-xs text-muted-foreground mt-1">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Statistics */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {stats?.map((stat, index) => (
          <div key={index} className="text-center">
            <div className="text-2xl font-bold text-primary">
              {stat?.value}
            </div>
            <div className="text-xs text-muted-foreground">
              {stat?.label}
            </div>
          </div>
        ))}
      </div>
      {/* Security Badges */}
      <div className="flex justify-center items-center space-x-6 opacity-60">
        <div className="flex items-center space-x-2">
          <Icon name="Shield" size={16} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">SSL Secured</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">GDPR Compliant</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Award" size={16} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">501(c)(3) Verified</span>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;